import { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextRecibos } from "src/Contexts/Recibos/RecibosContext";
import { AccordionCore } from "src/Pages/components/AccordionCore/AccordionCore";

import { PDFConfirmationReceipt } from "../../components/Report/PDF/ConfirmationReceipt";

import { FormReceipt } from "./Components/Form/FormReceipt";
import { ResumoPDF } from "./Components/ResumePDF/ResumoPDF";

export const PageRecibos = () => {
  const { userPerfil } = useAuthContext();
  const { loadingGravar } = useConfigPageContext();
  const { listRecibos, setListRecibos } = useContextRecibos();

  const [value, setValue] = useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <AccordionCore title="Clique para abrir o filtro" defaultExpanded>
        <FormReceipt />
      </AccordionCore>

      <TabContext value={value}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Recibos de confirmações" value="1" />
          <Tab label="Resumo de pagamento" value="2" />
        </Tabs>

        <TabPanel sx={{ padding: 0 }} value="1">
          <PDFConfirmationReceipt
            isLoading={loadingGravar}
            listRecibos={listRecibos}
            nomeEmpresa={userPerfil?.empresa.nome}
            setListRecibos={setListRecibos}
            key={1}
            title="Recibo de confirmações"
          />
        </TabPanel>

        <TabPanel sx={{ padding: 0 }} value="2">
          <ResumoPDF
            isLoading={loadingGravar}
            listRecibos={listRecibos}
            setListRecibos={setListRecibos}
            key={2}
            title="Resumo de pagamento"
            nomeEmpresa={userPerfil?.empresa.nome}
          />
        </TabPanel>
      </TabContext>
    </>
  );
};
